import { fetchMusicLinksAdminAPI, getMusicLinksAdminAPI, getMusilinksHistoryAdminAPI, getMusilinksSearchLogAdminAPI, getLogosAPI } from "./api";

export function fetchMusicLinksAdmin(data) {
  return new Promise((resolve, reject) => {
    fetchMusicLinksAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function getMusicLinksAdmin(data) {
  return new Promise((resolve, reject) => {
    getMusicLinksAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function getMusilinksHistoryAdmin(data) {
  return new Promise((resolve, reject) => {
    getMusilinksHistoryAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function getMusilinksSearchLogAdmin(data) {
  return new Promise((resolve, reject) => {
    getMusilinksSearchLogAdminAPI(data)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}

export function getLogos() {
  return new Promise((resolve, reject) => {
    getLogosAPI()
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
}
